import AlphaShowcaseInfoText from './AlphaShowcaseInfoText';

export default AlphaShowcaseInfoText;
